import { render, staticRenderFns } from "./xi_tun_bao.vue?vue&type=template&id=0ed39b12"
import script from "./xi_tun_bao.vue?vue&type=script&lang=js"
export * from "./xi_tun_bao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports